module.exports = __webpack_public_path__ + "static/media/  (111).6a2ac266.jpg";